import { render, staticRenderFns } from "./ManoeuvreRatingTranslation.vue?vue&type=template&id=64a965f8"
import script from "./ManoeuvreRatingTranslation.vue?vue&type=script&lang=js"
export * from "./ManoeuvreRatingTranslation.vue?vue&type=script&lang=js"
import style0 from "./ManoeuvreRatingTranslation.vue?vue&type=style&index=0&id=64a965f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports